import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';


const CssTextField = withStyles({
  root: {
    '& .MuiInputLabel-formControl': {
      top: '-2px'
    },
    '& label.Mui-focused': {
      color: '#9c9595',


    },
    '& .MuiInput-underline:after': {
      borderColor: '#9c9595',
      borderRadius: '0'
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: 2,
    },
    '& .MuiOutlinedInput-adornedStart': {
      paddingLeft: 3,
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#9c9595',
        borderRadius: '0'
      },
      '&:hover fieldset': {
        borderColor: '#9c9595',
        borderRadius: '0',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#9c9595',
        borderRadius: '0'
      },
      height: '30px',
      maxHeight: '30px',
      '&.MuiInputBase-multiline': {
        height: 'auto',
        maxHeight: 'none'
      }
    },

  },
})(TextField);

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    marginRight: '2px',
    marginBottom: '10px'
  },
}));

export default function CustomizedInputs(props) {
  const classes = useStyles();

  return (
    <>
      <CssTextField
        className={classes.margin}
        label={props.label}
        variant={props.variant}
        id={props.id}
        size={props.size}
        name={props.name}
        autoFocus={false}
        inputProps={{
          maxLength: props.maxLength,
          pattern: props.pattern,
          readOnly: props.readOnly,
        }}
        InputProps={{
          startAdornment: props.startAdornment ? <InputAdornment position="start">{props.startAdornment}</InputAdornment> : '',
          endAdornment: props.endAdornment ? <InputAdornment position="end">{props.endAdornment}</InputAdornment> : '',
        }}
        {...props}
      />
    </>
  );
}